import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { FilterPill } from './MachineCsv.styled';

function FieldFilter({
  field, label, selected, onSelect
}) {
  const handleClick = useCallback(() => onSelect(field), [onSelect, field]);
  return (
    <FilterPill type="button" aria-pressed={selected} selected={selected} onClick={handleClick}>
      {label}
    </FilterPill>
  );
}

FieldFilter.propTypes = {
  field: PropTypes.string,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
};

FieldFilter.defaultProps = {
  field: null
};

export default FieldFilter;
